<template>
<div>
  <div v-if="imgUrlList.length >= 1">
    <div class="img-contianer">
        <img :style="{'width': imgWidth}" :src="parseImgUrl(imgUrlList[currentIndex])" />
    </div>
    <el-row  type="flex" justify="center" v-show="showNext">
      <el-col :span="8">
        <el-button :disabled="hasNext" @click="prev" type="primary">上一张</el-button>
        <el-button :disabled="hasNext" @click="next" type="primary">下一张</el-button>
      </el-col>
    </el-row>
  </div>
  <div v-else>
    <el-row type="flex" justify="space-around">
      <el-col :span="8">
        暂无图片
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import { parseImgUrl } from 'src/filter/modules/img.js';
export default {
  name: "img-container",
  components: {},
  props: {
    imgUrlList: {
      type: Array,
      default: () => ([])
    },
    showNext: {
      type: Boolean,
      default: true
    },
    imgWidth: {
      type: String,
      default: '255px'
    }
  },
  methods: {
    prev() {
      if(this.currentIndex == 0) {
        this.currentIndex = this.imgUrlList.length -1;
        return;
      }
      this.currentIndex --;
    },
    next() {
      if(this.currentIndex >= this.imgUrlList.length -1) {
        this.currentIndex = 0;
        return;
      }
      this.currentIndex ++;
    }
  },
  mounted() {
  },
  data() {
    return {
      parseImgUrl,
      currentIndex:0
    };
  },
  computed:{
    hasNext() {
      return this.imgUrlList.length <= 1;
    }
  }
};
</script>

<style scoped>
.img-contianer {
  text-align: center;
}
</style>
